/**
 * Every boat in the lodge fleet. Staff assign a specific boat to a booking,
 * and a boat can only be on one booking per night.
 */
export const FLEET = [
  'Miss Bonnie',
  'Caroline Rose',
  'Kali Rose',
  'Heather Kristine',
  'Roonie Too',
  "Hailey's Comet",
] as const

export type BoatName = (typeof FLEET)[number]

export function isFleetBoat(name: string): name is BoatName {
  return (FLEET as readonly string[]).includes(name)
}
